import React from 'react';

import EmojiCamera from '../../assets/emoji_camera.webp';
import EmojiChair from '../../assets/emoji_chair.webp';
import EmojiLink from '../../assets/emoji_link.webp';

import MobileEmojiCamera from '../../assets/mobile/emoji_camera.webp';
import MobileEmojiChair from '../../assets/mobile/emoji_chair.webp';
import MobileEmojiLink from '../../assets/mobile/emoji_link.webp';

import ProcessImages from '../../assets/process_images.webp';
import ProcessModel from '../../assets/process_model.webp';
import ProcessWeb from '../../assets/process_web.webp';

import MobileProcessImages from '../../assets/mobile/process_images.webp';
import MobileProcessModel from '../../assets/mobile/process_model.webp';
import MobileProcessWeb from '../../assets/mobile/process_web.webp';

const PROCESS_CONTENT = [
  {
    icon: [EmojiCamera, MobileEmojiCamera],
    heading: 'Send us images of your product',
    text: (
      <>
        Professional photographs aren’t necessary. <br />
        We just need them for reference
      </>
    ),
    image: [ProcessImages, MobileProcessImages],
  },
  {
    icon: [EmojiChair, MobileEmojiChair],
    heading: 'We create the 3D model for you',
    text: 'Our team of design experts create a web optimised 3D model of the product within 24hrs',
    image: [ProcessModel, MobileProcessModel],
  },
  {
    icon: [EmojiLink, MobileEmojiLink],
    heading: 'Access on any device with a browser',
    text: 'Get a URL that can be easily integrated in your website or shared with your customers',
    image: [ProcessWeb, MobileProcessWeb],
  },
];

class LandingProcess extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedSection: 0,
    };

    this.autoswitch = null;
  }

  setSelected = (selectedSection) => {
    this.setState({
      selectedSection,
    });
  };

  componentDidMount() {
    this.startAutoswitch();
  }

  componentWillUnmount() {
    this.stopAutoSwitch();
  }

  startAutoswitch = () => {
    if (this.autoswitch) {
      return;
    }
    this.autoswitch = setInterval(this.incrementSelected, 3000);
  };

  stopAutoSwitch = () => {
    if (this.autoswitch) {
      clearInterval(this.autoswitch);
      this.autoswitch = null;
    }
  };

  incrementSelected = () => {
    const { selectedSection } = this.state;
    this.setSelected((selectedSection + 1) % PROCESS_CONTENT.length);
  };

  render() {
    const { selectedSection } = this.state;
    return (
      <div className="landing-width-limit padding-lr-30" id="landing-process">
        <div
          id="landing-process-content"
          onPointerEnter={this.stopAutoSwitch}
          onPointerLeave={this.startAutoswitch}>
          {PROCESS_CONTENT.map(({ icon, heading, text, image }, index) => (
            <div
              key={heading}
              className={`landing-process-item ${selectedSection === index ? 'selected' : ''}`}
              onClick={() => this.setSelected(index)}
              onPointerEnter={() => this.setSelected(index)}>
              <img
                src={icon[0]}
                srcSet={`${icon[0]} 100w, ${icon[1]} 50w`}
                width={100}
                height={100}
                alt=""
                className="landing-process-icon"
                loading="lazy"
              />
              <div>
                <h3 className="landing-process-item-heading">{heading}</h3>
                <p className="landing-process-item-text">{text}</p>
                <img
                  src={image[0]}
                  srcSet={`${image[0]} 1400w, ${image[1]} 700w`}
                  width={1400}
                  height={1000}
                  alt=""
                  className="landing-process-item-img"
                  loading="lazy"
                />
              </div>
            </div>
          ))}
        </div>
        <img
          id="landing-process-img"
          alt=""
          srcSet={`${PROCESS_CONTENT[selectedSection].image[0]} 1400w, ${PROCESS_CONTENT[selectedSection].image[1]} 700w`}
          width={1400}
          height={1000}
          src={PROCESS_CONTENT[selectedSection].image[0]}
          loading="lazy"
        />
      </div>
    );
  }
}

export default LandingProcess;
